import React, { useState } from 'react';
import { Modal, Button, Checkbox, Space, Typography, Card, Flex, Result } from 'antd';
import { FilePdfOutlined, FileProtectOutlined, CheckCircleOutlined, SafetyCertificateOutlined, LockOutlined } from '@ant-design/icons';

const { Title, Text, Link, Paragraph } = Typography;

export const ModalTerminos = ({ visible, onAccept }) => {
  const [aceptoPrivacidad, setAceptoPrivacidad] = useState(false);
  const [aceptoConfidencialidad, setAceptoConfidencialidad] = useState(false);

  const handleAceptar = () => {
    if (aceptoPrivacidad && aceptoConfidencialidad) {
      onAccept();
    }
  };

  const puedeAceptar = aceptoPrivacidad && aceptoConfidencialidad;

  return (
    <Modal
      open={visible}
      closable={false}
      maskClosable={false}
      centered
      width={600}
      footer={null}
    >
      <Result
        icon={<SafetyCertificateOutlined />}
        title="Términos y Condiciones"
        subTitle="Para continuar es necesario que acepte los siguientes documentos"
        extra={
          <Flex vertical gap="large" style={{ width: '100%' }}>
            <Card hoverable size="small">
              <Flex justify="space-between" align="center">
                <Space>
                  <FilePdfOutlined style={{ fontSize: 24 }} />
                  <Link
                    href="https://sigsa.blob.core.windows.net/generico/FOR-AVP-02 Formato Aviso de Privacidad Proveedores Vr.1.0.pdf"
                    target="_blank"
                    strong
                  >
                    Aviso de Privacidad Proveedores
                  </Link>
                </Space>
                <Checkbox
                  checked={aceptoPrivacidad}
                  onChange={(e) => setAceptoPrivacidad(e.target.checked)}
                >
                  Acepto
                </Checkbox>
              </Flex>
            </Card>

            <Card hoverable size="small">
              <Flex justify="space-between" align="center">
                <Space>
                  <FilePdfOutlined style={{ fontSize: 24 }} />
                  <Link
                    href="https://sigsa.blob.core.windows.net/generico/FOR-CCF-02 Formato Convenio Confidencialidad Proveedores Vr.1.0.pdf"
                    target="_blank"
                    strong
                  >
                    Convenio de Confidencialidad
                  </Link>
                </Space>
                <Checkbox
                  checked={aceptoConfidencialidad}
                  onChange={(e) => setAceptoConfidencialidad(e.target.checked)}
                >
                  Acepto
                </Checkbox>
              </Flex>
            </Card>

            <Button
              type="primary"
              disabled={!puedeAceptar}
              onClick={handleAceptar}
              size="large"
              block
              icon={<CheckCircleOutlined />}
            >
              Aceptar y Continuar
            </Button>

            <Text type="secondary">
              <LockOutlined /> ESCOTEL 2026
            </Text>
          </Flex>
        }
      />
    </Modal>
  );
};
